

import React, { useEffect, useMemo, useState, Suspense, lazy } from 'react';

const PersonalInformation = ({ user }) => {



   

    return (<>
      <div className="row">
                                <div className="form-group mb-3 col-md-6">
                                    <label

                                        htmlFor="val-username"
                                    >
                                        Name 
                                    </label>
                                 
                                    <input component="input"
                                        placeholder=" "
                                        name="frommarks"
                                        className="form-control" value ={user?.name}

                                         maxLength={50} />


                                </div>


                                <div className="form-group mb-3 col-md-6">
                                    <label

                                        htmlFor="val-username"
                                    >
                                        Email 
                                    </label>

                                    <input component="input"
                                        placeholder=" "
                                        name="frommarks"
                                        className="form-control"

                                         maxLength={50}  value ={user?.email}/>


                                </div>

                                <div className="form-group mb-3 col-md-6">
                                    <label

                                        htmlFor="val-username"
                                    >
                                        Mobile No
                                    </label>
                                   
                                    <input component="input"
                                        placeholder=" "
                                        name="frommarks"
                                        className="form-control"

                                         maxLength={50}  value ={user?.username}/>

                                </div>


                                <div className="form-group mb-3 col-md-6">
                                    <label
                                        htmlFor="val-username"
                                    >
                                        State
                                    </label>

                                    <input component="input"
                                        placeholder=""
                                        name="frommarks"
                                        className="form-control" value ={user?.state}

                                         maxLength={50} />

                                </div>


                                <div className="form-group mb-3 col-md-6">
                                    <label

                                        htmlFor="val-username"
                                    >
                                    District
                                    </label>
                                    <input component="input"
                                        placeholder=""
                                        name="frommarks"
                                        className="form-control" value ={user?.district}

                                         maxLength={50} />


                                </div>

                                <div className="form-group mb-3 col-md-6">
                                    <label

                                        htmlFor="val-username"
                                    >
                                    Address
                                    </label>
                                    <input component="input"
                                        placeholder=""
                                        name="frommarks"
                                        className="form-control" value ={user?.address}

                                         maxLength={50} />


                                </div>


                                <br />


                                <div className="form-group mb-3 col-md-6">
                                    <label

                                        htmlFor="val-username"
                                    >
                                        IS Certified
                                    </label>
                                    <input component="input"
                                        placeholder=""
                                        name="frommarks"
                                        className="form-control"

                                         maxLength={50}  value ={user?.iscertified}/> 
                                 


                                </div>

                               
                              
                            </div>
    </>)

}
export default PersonalInformation

